// Chakra imports
import {
  Flex,
  Text,
  Table,
  Td,
  Tr,
  Thead,
  Th,
  Tbody,
  IconButton,
  Icon,
  TableContainer,
} from "@chakra-ui/react";
import LoadingSpinner from "components/loadingSpinner/LoadingSpinner";
// Custom components
import Card from "components/card/Card";
import { format } from "date-fns";
// Assets
import { useEffect, useState } from "react";
import { buscarHistoricoMidia } from "config/apis/requests";
import { IsEmpty } from "config/functions";
import {
  MdAutoStories,
  MdRefresh,
  MdContentCut,
  MdSearch,
  MdBlock,
  MdCheckCircle,
  MdCancel,
  MdLock,
  MdLockOpen,
  MdAttachMoney,
  MdError,
} from "react-icons/md";
export default function HistoricoMidia(props: { idMidia: any }) {
  const [historicoMidia, setHistoricoMidia] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setHistoricoMidia([]); // Limpar o histórico imediatamente quando idMidia mudar
    const fetchHistorico = async () => {
      setLoading(true);
      if (!IsEmpty(props.idMidia)) {
        try {
          const res = await buscarHistoricoMidia(props.idMidia);
          setHistoricoMidia(res);
          setLoading(false);
        } catch (error) {
          setLoading(false);
        }
      } else {
        setHistoricoMidia([]);
        setLoading(false);
      }
    };

    fetchHistorico();
  }, [props.idMidia]);

  function statusIcon(id?: number) {
    switch (id) {
      case 0:
        return MdCheckCircle; // Criado
      case 1:
        return MdRefresh; // Inicialização
      case 2:
        return MdContentCut; // Personalização
      case 3:
        return MdAutoStories; // Associação
      case 4:
        return MdCancel; // Desassociação
      case 5:
        return MdLock; // Bloqueio
      case 6:
        return MdLockOpen; // Desbloqueio
      case 7:
        return MdCancel; // Cancelado
      case 8:
        return MdAttachMoney; // Carga gerada
      case 9:
        return MdAttachMoney; // Carga efetivada
      case 10:
        return MdBlock; // Cancelado fisicamente
      case 11:
        return MdSearch; // Reservado
      case 12:
        return MdError; // Estorno
      case 13:
        return MdLock; // Bloqueio entrega
      case 14:
        return MdBlock; // Bloqueio fraude
      case 15:
        return MdLockOpen; // Desbloqueio fraude
      default:
        return MdSearch; // fallback
    }
  }

  function statusColor(id?: number) {
    switch (id) {
      case 0:
        return "green.500"; // Criado
      case 1:
        return "blue.400"; // Inicialização
      case 2:
        return "purple.500"; // Personalização
      case 3:
        return "blue.500"; // Associação
      case 4:
        return "orange.500"; // Desassociação
      case 5:
        return "red.600"; // Bloqueio
      case 6:
        return "green.600"; // Desbloqueio
      case 7:
        return "red.500"; // Cancelado
      case 8:
        return "teal.500"; // Carga gerada
      case 9:
        return "teal.600"; // Carga efetivada
      case 10:
        return "red.700"; // Cancelado fisicamente
      case 11:
        return "gray.500"; // Reservado
      case 12:
        return "yellow.600"; // Estorno
      case 13:
        return "red.400"; // Bloqueio entrega
      case 14:
        return "red.800"; // Bloqueio fraude
      case 15:
        return "green.700"; // Desbloqueio fraude
      default:
        return "gray.400"; // fallback
    }
  }

  function statusDescricao(id?: number) {
    switch (id) {
      case 0:
        return "Cartão criado";
      case 1:
        return "Cartão inicializado";
      case 2:
        return "Personalização";
      case 3:
        return "Cartão associado";
      case 4:
        return "Cartão desassociado";
      case 5:
        return "Cartão bloqueado";
      case 6:
        return "Cartão ativo"; //"Cartão desbloqueado";
      case 7:
        return "Cartão cancelado";
      case 8:
        return "Carga gerada";
      case 9:
        return "Carga efetivada";
      case 10:
        return "Cartão cancelado fisicamente";
      case 11:
        return "Cartão reservado";
      case 12:
        return "Estorno";
      case 13:
        return "Cartão bloqueado entrega";
      case 14:
        return "Cartão bloqueio por uso indevido";
      case 15:
        return "Cartão desbloqueado (uso indevido)";
      default:
        return "Desconhecido";
    }
  }

  return (
    <>
      <Card
        flexDirection="column"
        height={"20%"}
        minHeight={"40px"}
        mb={"20px"}
      >
        <Text fontSize="xl" fontWeight="bold">
          Histórico do cartão
        </Text>

        <Flex
          direction="column"
          gap="10px"
          mt="20px"
          width={"100%"}
          height={"80%"}
          overflowX="auto"
          overflowY="auto"
        >
          {loading ? (
            <LoadingSpinner size="25px" />
          ) : historicoMidia.length > 0 ? (
            <TableContainer width="100%">
              <Table variant="simple" size="sm">
                <Tbody>
                  {historicoMidia.map((item, index) => (
                    <Tr key={index}>
                      <Td width="50px">
                        <IconButton
                          aria-label="Status icon"
                          borderRadius="50%"
                          icon={
                            <Icon
                              as={statusIcon(item?.idTipoEventoMidia)}
                              w="24px"
                              color={statusColor(item?.idTipoEventoMidia)}
                              h="24px"
                            />
                          }
                          variant="ghost"
                        />
                      </Td>
                      <Td whiteSpace="normal">
                        <b>{statusDescricao(item?.idTipoEventoMidia)}</b> às{" "}
                        {item?.dataEvento
                          ? format(
                              new Date(
                                new Date(item.dataEvento).getTime() - 3 * 60 * 60 * 1000
                              ),
                              "dd/MM/yyyy HH:mm:ss"
                            )
                          : "-"}
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          ) : (
            <Text fontSize="md" color="gray.500">
              Nenhum histórico encontrado para este cartão.
            </Text>
          )}
        </Flex>
      </Card>
    </>
  );
}
